<template>
  <div>
    <div v-if="isFetchingCircles" class="d-flex align-items-center flex-column justify-content-center mt-4">
      <div>
        <div class="spinner-border spinner-class"></div>
      </div>
      <div>Loading circles...</div>
    </div>
    <div class="AllCirclesCard" v-for="(circle, index) in otherCircle" :key="index">
      <div class="cardContainer">
        <div class="leftContent">
          <div v-if="circle.url !== null">
            <img class="CircleImage" :src="circle.url" />
          </div>
          <div v-else>
            <img class="CircleImage" src="../../../assets/images/CircleImage.png" />
          </div>
          <div class="info">
            <span class="CircleTitle" v-if="circle.condition_type">
              {{ circle.condition_type.slice(0, 30) }}
              {{ circle.condition_type.length > 30 ? "..." : "" }}
            </span>
            <span v-if="circle.description" class="CircleDesc">
              {{ circle.description.slice(0, 60) }}
              {{ circle.description.length > 60 ? "..." : "" }}
            </span>
          </div>
        </div>
        <div class="rightContent">
          <button class="SeeCircleButton" @click="goToCircle(circle, $event)" :loading="selectedCircle === circle.condition_type" :id="circle.enter ? 'enter' : 'register'">See Circle</button>
        </div>
      </div>
    </div>
    <div class="pagination-container">
      <a-pagination v-model="currentPage" :total="pagination ? pagination : 0" show-less-items :pageSize="8" @change="handleChangePage" />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { eventBus } from "../../../main"
import SSOLogin from "../../login/login-register-component.vue"
import SSOModal from "../../login/login-register-modal.vue"
import PatientStatic from "./AllCircleStaticPages/patientStatic.vue"
import AdvocateStatic from "./AllCircleStaticPages/AdvocateStatic.vue"
import HealthcareStatic from "./AllCircleStaticPages/HealthCareProfessionalStatic.vue"
import AccVerifyModal from "../../Modals/AccountNotVerifiedWarning.vue"
import PartnerStatic from "./AllCircleStaticPages/PartnerStatic.vue"
import HealthCareAdmin from "./AllCircleStaticPages/HealthCareAdmin.vue"
import { ref } from "vue"
const AppRepository = RepositoryFactory.get("app")
const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")

import { faUser, faHandshakeAlt, faCheckCircle } from "@fortawesome/pro-light-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import { ErrorBag } from "vee-validate"

library.add(faUser, faHandshakeAlt, faCheckCircle)

/**
 * Circle Management
 * @displayName Circles
 */
export default {
  name: "CirclesAll",

  components: {
    SSOLogin,
    SSOModal,
    PatientStatic,
    AdvocateStatic,
    HealthcareStatic,
    AccVerifyModal,
    PartnerStatic,
    HealthCareAdmin,
  },

  data() {
    return {
      pagination: 0,
      currentPage: 1,
      itemLimit: 8,
      allCircles: null,
      myCircles: null,
      joinedCircle: [],
      otherCircle: [],
      isFetchingCircles: false,
      selectedCircle: false,
      enteredCircles: [],
      userAdminRoles: ["hospital_administrator", "clinic_administrator", "doctor", "nfp_administrator", "hcp"],
    }
  },

  watch: {
    "$store.state.User.user": function() {
      this.$router.go()
    },
    allCircles: function() {
      this.joinedCircle = this.allCircles.filter(ele => ele.enter === true)
      this.otherCircle = this.allCircles.filter(ele => ele.enter !== true)
    },
  },

  created() {
    console.warn("CircleAll.vue is created")
    eventBus.$on("refresh-circle-members-rootlogin", () => {
      this.init()
    })
  },

  mounted() {
    this.$store.commit("Posts/resetPosts")
    this.init()
  },

  methods: {
    /**
     * Initialization
     */

    async init(page) {
      console.log(page)
      if (page === undefined) {
        page = 1
      }
      this.isFetchingCircles = true
      await CircleRepository.all("", "", page, 8)
        .then(async res => {
          this.enteredCircles = res.data.data.my_circles
          this.myCircles = this.authUser ? (this.authUser.user.hasOwnProperty("verified_account") ? res.data.data.all_circles : res.data.data.my_circles) : []
          this.pagination = res.data.paginator.total_count
          if (this.authUser) {
            if (this.authUser.user.hasOwnProperty("verified_account")) {
              // this.allCircles = await res.data.data.all_circles;
              this.allCircles = await res.data.data.not_my_circles
            } else {
              this.allCircles = await this.circleDiff(
                // res.data.data.all_circles
                res.data.data.not_my_circles
              )
            }
          } else {
            this.allCircles = await res.data.data.all_circles
          }
          this.isFetchingCircles = false
        })
        .catch(err => {
          this.isFetchingCircles = false
        })
    },

    handleChangePage(page) {
      console.log(page, "pageination")
      this.currentPage = page
      this.init(page)
      console.log("scrolling...")
      window.scrollTo(0, 0)
    },

    /**
     * Filter circles based on the condition that it's present in mycicles or not
     *
     * @param {Array} allCircles
     */

    circleDiff(allCircles) {
      if (this.authUser) {
        const userCircles = this.enteredCircles || []
        // const userCircles = this.enteredCircles || this.authUser.user.circles
        allCircles.forEach(a => {
          const found = userCircles.some(b => b.id === a.id)
          if (found) {
            a["enter"] = true
          }
        })

        return allCircles
      }
    },

    getStartedButton() {
      if (!this.authUser) {
        document.body.scrollTop = 0

        setTimeout(() => {
          this.$refs.modal.open()
        }, 1000)
      } else if (this.authUser && this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
        this.$refs.accVerify.showModal()
      } else {
        document.body.scrollTop = 300
      }
    },

    /**
     * Go to diffeent circle page based on user selection
     *
     * @param {Object} circle
     * @param {Object} event
     */
    goToCircle(circleInfo, event) {
      this.selectedCircle = circleInfo.condition_type
      const target = event.target.id

      CircleRepository.all("", circleInfo.id)
        .then(res => {
          let circle = res.data.data.all_circles[0]
          this.$store.dispatch("Circle/diseaseTypes", { type: circle.id })
          this.$store.commit("Circle/setCurrentCircle", { data: circle })
          target === "enter" ? this.checkAndRoute(circle) : this.goToCircleDescription(circle) //if there is more than one role to enable to there is more role do a if condition here with the new api
        })
        .catch(err => {
          console.log(err)
        })
    },

    goToCircleDescription(data) {
      this.$store.dispatch("Circle/diseaseTypes", { type: data.id })
      this.$store.commit("Circle/setCurrentCircle", { data: data })

      this.$router.push({
        name: "CircleDescription",
        params: {
          circle: this.currentCircle.key_name,
        },
        query: {
          circle_id: this.currentCircle.id,
        },
      })
    },

    checkAndRoute(circle) {
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole

            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.circle_id === this.currentCircle.id)[0].role

            const payload = {
              role: selectedRole,
              circle_id: this.currentCircle.id,
            }

            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                console.log("I AM CALLING")
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          }
          if (res.data.data.length === 1) {
            const payload = {
              role: res.data.data[0].role,
              circle_id: this.currentCircle.id,
            }

            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                console.log("I AM CALLING")
                this.authUser.user.display_name = res.data.data.user_info.display_name
                // this.authUser.user.display_name = res.data.data.user_info.display_name.toLowerCase()
                this.authUser.user.first_post = res.data.data.user_info.first_post
                this.authUser.user.role = payload.role
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          }
          if (res.data.data.length > 1) {
            this.$router.push(`/${this.currentCircle.key_name}/select-profile`)
          }
        })
        .catch(err => {})
    },

    goToCrisisPage() {
      this.$router.push({
        name: "CrisisHelpline",
      })
    },

    goToRole(circle, event) {
      const target = event.target.id
      if (target === "enter") this.$router.push(`/${circle.key_name}/select-profile`)
    },

    enterCircle(circle, event, bool) {
      event.target.id === "enter" ? this.checkAndRoute(circle, bool) : this.$router.push(`/${circle.key_name}/signup`).catch(err => {})
    },

    handleSelectBox(num) {
      const x = document.querySelectorAll(".choose-role--box")
      const y = document.querySelectorAll(".choose-box--description")
      const roleLabel = document.querySelectorAll(".choose-role--box__big")
      for (let i = 0; i < x.length; i++) {
        if (x[i].classList.contains("selected")) {
          x[i].classList.remove("selected")
          y[i].classList.remove("show-class")
          y[i].classList.add("none-class")
          roleLabel[i].classList.remove("active-label")
        }
      }
      x[num].classList.add("selected")
      y[num].classList.add("show-class")
      y[num].classList.add("selected-box")
      roleLabel[num].classList.remove("active-label")
      y[num].classList.remove("none-class")
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 792px;
  height: 36px;
}
.CircleTitle {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  height: 30px;
}

.CircleDesc {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  height: 48px;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
}

.CircleImage {
  object-fit: cover;
  width: 207px;
  height: 128px;
}
.SeeCircleButton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 159px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.rightContent {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 48px;
  width: 159px;
  height: 48px;
}

.leftContent {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 48px 0px 0px;
  gap: 16px;
  width: 595px;
  height: 128px;
}
.cardContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 754px;
  height: 128px;
}

.AllCirclesCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  width: 792px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  border-radius: 4px;
  margin-bottom: 16px;
}
.left-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px 24px;
  gap: 16px;
  position: absolute;
  width: 382px;
  height: 198px;
  left: 120px;
  top: 123px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.left-container-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 94px;

  width: 334px;
  height: 30px;
}

.left-container-choices:hover {
  background: #f1f5f9;
}

.left-container-choices {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 16px;
  width: 334px;
  height: 40px;
}

.right-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  position: absolute;
  width: 792px;
  height: 1642px;
  right: 120px;
  top: 125px;
}

.upper-container {
  width: 792px;
  height: 166px;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.wrapper {
  position: absolute;
  top: -10px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 744px;
  height: 118px;
}
.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  width: 298px;
  height: 42px;
}

input[type="text"]::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

form.nosubmit {
  border: none;
  padding: 0;
}

input.nosubmit {
  position: relative;
  top: -10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: #f8fafd;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 4px 4px 4px 48px;
  gap: 8px;
  font-size: 16px;
  line-height: 32px;
  width: 744px;
  height: 60px;
  background-image: url("../../../assets/images/search-icon.png");
  background-repeat: no-repeat;
  background-position: 18px;
  color: #94a3b8;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/CirclesAll.vue